import { useTranslation } from 'react-i18next'

import { SHIPMENT_STAGES } from '#/entities/shipment'
import type { ShipmentStage } from '#/entities/shipment'
import { formatUsd } from '#/shared/lib/format'
import { cn } from '#/shared/lib/utils'
import type { ShipmentListCardRow } from '../model/types'
import { LeadFooter } from './lead-footer'

function PriceSummary({
  amount,
  secondaryLabelKey,
  secondaryAmount,
  secondaryClassName,
}: {
  amount?: number
  secondaryLabelKey: string
  secondaryAmount?: number
  secondaryClassName: string
}) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-1.5">
      <span className="text-base font-semibold text-gray-900">
        {formatUsd(amount)}
      </span>
      {secondaryAmount != null && (
        <span className={cn('text-xs font-medium', secondaryClassName)}>
          · {t(secondaryLabelKey, { amount: formatUsd(secondaryAmount) })}
        </span>
      )}
    </div>
  )
}

export function CardFooter({
  row,
  stage,
}: {
  row: ShipmentListCardRow
  stage: ShipmentStage
}) {
  if (stage === SHIPMENT_STAGES.LEAD) {
    return (
      <LeadFooter
        shipmentId={row.shipmentId}
        tariff={row.tariff}
        deposit={row.deposit}
      />
    )
  }

  if (stage === SHIPMENT_STAGES.ORDER) {
    return (
      <PriceSummary
        amount={row.tariff}
        secondaryLabelKey="shipmentCard.carrier"
        secondaryAmount={row.tariffPrevious}
        secondaryClassName="text-amber-700"
      />
    )
  }

  return (
    <PriceSummary
      amount={row.tariff}
      secondaryLabelKey="shipmentCard.deposit"
      secondaryAmount={row.deposit}
      secondaryClassName="text-gray-500"
    />
  )
}
